import { z } from 'zod';

import { localized as messages } from './sdd-localize';
import { validateZipPostalCode } from './validate-zip-postal-code';

export const getFormSchema = () =>
    z.object({
        streetLine1: z.string().trim().min(1, messages.streetAddressValidation).max(500),
        streetLine2: z.string().trim().optional(),
        city: z.string().trim().min(1, messages.cityValidation).max(100),
        stateProvince: z.string().trim().min(1, messages.stateProvinceValidation),
        zipPostalCode: z.string().trim().min(1, messages.zipPostalCodeValidation).refine(validateZipPostalCode, {
            message: messages.zipPostalCodeValidationInvalid,
        }),
    });
